import { Button } from "react-bootstrap";
import { openInNewTab } from "../Utils/utils";
import { LuFacebook, LuInstagram, LuLinkedin } from "react-icons/lu";
const Social = ({ icon, callback, iconColor, style }) => {
  return (
    <Button className={`btn iconSocial m-2 ${style}`} onClick={() => openInNewTab(callback)}>
      <div className="d-flex justify-content-center align-items-center align-content-center ">
        {icon === "fb" && <LuFacebook size={26} color={iconColor} />}
        {icon === "ig" && <LuInstagram size={26} color={iconColor} />}
        {icon === "in" && <LuLinkedin size={26} color={iconColor} />}
      </div>
    </Button>
  );
};

export default Social;
